export const extractLinkedInUsername = (input: string): string => {
  if (!input) return '';

  let username = input.trim();

  // Strip query parameters
  if (username.includes('?')) {
    username = username.split('?')[0];
  }

  // Strip common prefixes including common typos
  const prefixes = [
    'https://www.linkedin.com/in/',
    'http://www.linkedin.com/in/',
    'https://linkedin.com/in/',
    'http://linkedin.com/in/',
    'www.linkedin.com/in/',
    'linkedin.com/in/',
    'www.linkedin.comin/', // typo: missing dot
    'linkedin.comin/', // typo: missing dot
    'www.linkedin.comin', // typo: missing dot and slash
    'linkedin.comin', // typo: missing dot and slash
    'linkedincom/in/', // typo: missing dot
    '/in/',
    'in/',
  ];

  for (const prefix of prefixes) {
    if (username.toLowerCase().startsWith(prefix.toLowerCase())) {
      username = username.substring(prefix.length);
      break;
    }
  }

  // Strip trailing slashes
  while (username.endsWith('/')) {
    username = username.slice(0, -1);
  }

  return username;
};

//Builds a full LinkedIn URL from a username.

export const buildLinkedInUrl = (username: string): string => {
  if (!username) return '';
  const cleanUsername = username.trim().replace(/^\/+|\/+$/g, '');
  return `https://www.linkedin.com/in/${cleanUsername}`;
};

export const isLinkedInUrl = (input: string): boolean => {
  if (!input) return false;
  const lowerInput = input.trim().toLowerCase();

  // If it starts with common protocols or domains, it's definitely a URL/prefix
  if (
    lowerInput.startsWith('http') ||
    lowerInput.startsWith('www.') ||
    lowerInput.includes('linkedin.com') ||
    lowerInput.includes('linkedin.comin')
  ) {
    return true;
  }

  return lowerInput.includes('.') || lowerInput.includes('/');
};
